<accordion
	[isOpen]="true"
	[title]="'APPOINTMENTS.DETAILS.BODY.TASK_DATA.TITLE' | translate"
	icon="list-check"
	(onToggle)="onToggleAccordion($event)"
>
	<div class="zk-flex zk-flex-col zk-mt-2 zk-gap-2">
		<div *ngIf="description">
			<p id="orientation_title" freud-typography fontType="bodySemibold1-5">
				{{ 'APPOINTMENTS.DETAILS.BODY.TASK_DATA.ORIENTATIONS' | translate }}
			</p>
			<p
				id="orientation_text"
				class="orientation_text"
				freud-typography
				fontType="bodyRegular1-2"
			>
				{{ description }}
			</p>
		</div>
		<div *ngIf="links.length > 0">
			<p id="link_title" freud-typography fontType="bodySemibold1-5">
				{{ 'APPOINTMENTS.DETAILS.BODY.TASK_DATA.LINK' | translate }}
			</p>
			<div
				*ngFor="let link of links"
				class="zk-flex zk-flex-col zk-gap-1"
				(click)="preventAccordionToggle($event)"
			>
				<a
					href="{{ link.specifications.url }}"
					target="_blank"
					rel="noopener noreferrer"
					freud-typography
					fontType="bodyRegular1-2"
					>{{ link.specifications.url }}</a
				>
			</div>
		</div>
	</div>
</accordion>
